{
  "version": 1,
  "asset_id": "d543fea1-9f02-45f2-862b-69e544d46eec",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/d543fea1-9f02-45f2-862b-69e544d46eec/hernando-galvalume-metal-roof-aerial-480w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/d543fea1-9f02-45f2-862b-69e544d46eec/hernando-galvalume-metal-roof-aerial-480w.webp",
  "original_filename": "hernando-galvalume-metal-roof-aerial-480w.webp",
  "size": 26154,
  "content_type": "image/webp",
  "created_at": "2026-07-21T19:37:52Z"
}
